import React from "react";
import { render } from "react-dom";
import Lister from "../widgets/lister";


// Book lister
let listerElem = document.querySelector(".widget-lister");
if (listerElem) render(<Lister elem={listerElem} />, listerElem);